module.exports = __webpack_public_path__ + "static/media/Cassandra.e39e1f5c.jpg";